/**
 * Check if a given value is it null or undefined
 * @param {value} - Value to check
 * @return {boolean} - Whether if the given value is null/undefined or not
 */
export const isNullUndefined = (value: string | number | boolean): boolean => value === null || value === undefined;
